import React, {Fragment} from "react";
import BasicModal from "../../../../common/BasicModal";
import {basicModalStyle} from "../../Utilities/basicModalStyles";
import CustomerIoSetupForm from "./CustomerIoSetupForm";

export default function CustomerIoSetupModal({open, handleClose, handleOpen}){
    return(
        <Fragment>
            <BasicModal
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
                title={'Connect with customer.io'}
                style={basicModalStyle}
            >
                <CustomerIoSetupForm
                    description={'Please copy and paste your customer.io credentials here:'}
                    buttonLabel={'Submit'}
                    handleClose={handleClose} />
            </BasicModal>
        </Fragment>
    )
}